document.addEventListener("DOMContentLoaded", function() {
    // Select all elements with the class "js-section"
    const sections = document.querySelectorAll(".js-parallax-section");
    const parallaxWrappers = document.querySelectorAll(".parallax-wrapper");


    // Options for the Intersection Observer
    const observerOptions = {
        root: null, // Use the viewport as the container
        rootMargin: "0px", // No margin around the root
        threshold: 0.1 // Trigger when 10% of the element is visible
    };

    const visibleSections = new Set();
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    let lastScrollDirection = "down";
    let opacityTicking = false;
    let parallaxTicking = false;
    const supportsIntersectionObserver = "IntersectionObserver" in window;

    // Create a new Intersection Observer with the specified options
    let observer = null;
    if (supportsIntersectionObserver) {
        observer = new IntersectionObserver(handleIntersect, observerOptions);

        // Observe each section
        sections.forEach(section => {
            observer.observe(section);
        });
    }

    /**
     * Updates the background positions of all parallax wrappers based on scroll position.
     * This creates a parallax scrolling effect.
    */

    function updateParallaxBackgrounds() {
        parallaxTicking = false;
        const viewportHeight = window.innerHeight;

        parallaxWrappers.forEach(wrapper => {
            const rect = wrapper.getBoundingClientRect();

            if (rect.bottom < 0 || rect.top > viewportHeight) {
                return;
            }

            const speedAttr = parseFloat(wrapper.getAttribute("data-parallax-speed"));
            const speed = Number.isFinite(speedAttr) ? speedAttr : 0.35;
            const offset = -rect.top * speed;

            wrapper.style.backgroundPosition = `var(--parallax-position-x, 50%) calc(var(--parallax-position-y, 50%) + ${offset.toFixed(2)}px)`;
        });
    }


    /**
     * Schedules an update to the parallax backgrounds using requestAnimationFrame.
     * This ensures the update is performed efficiently without causing performance issues.
    */

    function scheduleParallaxUpdate() {
        if (parallaxTicking || !parallaxWrappers.length) {
            return;
        }

        parallaxTicking = true;
        window.requestAnimationFrame(updateParallaxBackgrounds);
    }

    if (parallaxWrappers.length) {
        updateParallaxBackgrounds();
        window.addEventListener("scroll", scheduleParallaxUpdate, { passive: true });
        window.addEventListener("resize", scheduleParallaxUpdate);
    }

    // Handle intersection changes
    /**
     * Handles the intersection observer callback for sections.
     * Manages scroll event listeners based on section visibility in the viewport.
     * When a section enters the viewport, attaches a scroll handler to adjust opacity.
     * When a section leaves the viewport, removes the scroll handler and resets opacity to 0.
     *
     * @param {IntersectionObserverEntry[]} entries - Array of intersection observer entries representing sections being observed
     * @returns {void}
     */
    function handleIntersect(entries) {
        entries.forEach(entry => {
            const section = entry.target; // The current section being observed

            if (entry.isIntersecting) {
                visibleSections.add(section);
            } else {
                visibleSections.delete(section);
                section.style.opacity = 0; // Set opacity to 0 when out of view
            }
        });

        scheduleOpacityUpdate();
    }

    // Adjust opacity based on scroll position and direction
    function adjustOpacity(section, scrollDirection, viewportHeight) {
        const sectionRect = section.getBoundingClientRect(); // Get the section"s position
        const sectionCenter = sectionRect.top + sectionRect.height / 2; // Calculate the section"s center
        const viewportCenter = viewportHeight / 2; // Calculate the viewport"s center

        // Calculate opacity based on scroll direction and position
        let opacity;
        if (scrollDirection === "down") {
            if (sectionCenter <= viewportCenter) {
                // Increase opacity as the section center approaches the viewport center
                opacity = Math.min(1, (sectionCenter / viewportCenter).toFixed(1));
            } else {
                // Decrease opacity as the section center moves past the viewport center
                opacity = Math.max(0, (1 - ((sectionCenter - viewportCenter) / viewportCenter)).toFixed(1));
            }
        } else {
            if (sectionCenter >= viewportCenter) {
                // Increase opacity as the section center approaches the viewport center
                opacity = Math.min(1, ((viewportHeight - sectionCenter) / viewportCenter).toFixed(1));
            } else {
                // Decrease opacity as the section center moves past the viewport center
                opacity = Math.max(0, (sectionCenter / viewportCenter).toFixed(1));
            }
        }

        // Set the calculated opacity
        section.style.opacity = opacity;
    }

    function updateVisibleSectionsOpacity() {
        opacityTicking = false;
        if (!visibleSections.size) {
            return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
            lastScrollDirection = "down";
        } else if (scrollTop < lastScrollTop) {
            lastScrollDirection = "up";
        }
        lastScrollTop = scrollTop;

        const viewportHeight = window.innerHeight;
        visibleSections.forEach(section => {
            adjustOpacity(section, lastScrollDirection, viewportHeight);
        });
    }

    function scheduleOpacityUpdate() {
        if (opacityTicking || !visibleSections.size) {
            return;
        }

        opacityTicking = true;
        window.requestAnimationFrame(updateVisibleSectionsOpacity);
    }

    window.addEventListener("scroll", scheduleOpacityUpdate, { passive: true });
    window.addEventListener("resize", scheduleOpacityUpdate);

    function isSectionInViewport(section) {
        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        return rect.bottom > 0 && rect.top < viewportHeight;
    }

    // Prime visibility on load for browsers where IntersectionObserver may not fire immediately.
    if (!supportsIntersectionObserver) {
        sections.forEach(section => visibleSections.add(section));
    } else {
        sections.forEach(section => {
            if (isSectionInViewport(section)) {
                visibleSections.add(section);
            }
        });
    }
    scheduleOpacityUpdate();
});
